import React, { Component } from 'react'
import log from 'lib/log'
import LoadingPlaceholder from 'components/LoadingPlaceholder'
import ErrorPlaceholder from 'components/ErrorPlaceholder'
import createLogger from 'debug'
import RequiresRegistration from './RequiresRegistration'

export const info = createLogger('info:ui')

// todo: refactor using StateMachine
class LoadingLoadedOrExploded extends Component {
  static getDerivedStateFromProps() {
    return { error: undefined }
  }
  constructor(props) {
    super(props)
    this.state = {}
  }
  componentDidCatch(error, info) {
    this.setState({ error })
    log.error(error, info)
    // todo: log to a remote logging service ...
  }
  render() {
    const {
      loading,
      loaded,
      error,
      loadingComponent: LoadingComponent,
      loadedComponent: LoadedComponent,
      errorComponent: ErrorComponent,
      ...rest
    } = this.props
    const { error: caught } = this.state
    if (caught) {
      info("LoadingLoadedOrExploded %o, %o", LoadedComponent, error)
      return <ErrorPlaceholder error={caught.message} />
    }

    if (loaded && !(loading || error)) {
      return (
        (LoadedComponent && (
          <LoadedComponent {...loaded} {...rest} {...this.props} />
        )) ||
        null
      )
    }

    if (error) {
      info("LoadingLoadedOrExploded %o, %o", LoadedComponent, error)
      if (error === "authentication_required" || error === "access_denied") {
        return <RequiresRegistration />
      }
      return (
        (ErrorComponent && <ErrorComponent error={error} {...rest} />) || (
          <ErrorPlaceholder error={error} />
        )
      )
    }

    return (
      (LoadingComponent && <LoadingComponent {...rest} {...this.props} />) || (
        <LoadingPlaceholder />
      )
    )
  }
}

export default LoadingLoadedOrExploded
